import "./initFunctions";
import "./trackUtils";
import "./tagManager";
import "./vtm";

const trackUtils = require('./trackUtils');

trackUtils.exportRootVars();
trackUtils.exportComscoreVars();



// WEBPACK FOOTER //
// ./src/tracking/trackingVtm.js